import { render, staticRenderFns } from "./TaskChooser.vue?vue&type=template&id=19f3ec02&scoped=true"
import script from "./TaskChooser.vue?vue&type=script&lang=js"
export * from "./TaskChooser.vue?vue&type=script&lang=js"
import style0 from "./TaskChooser.vue?vue&type=style&index=0&id=19f3ec02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3ec02",
  null
  
)

export default component.exports